import { useEffect, useState } from "react";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";

const usePorcentPrice = (accessToken) => {
  const { url } = useDataContext();
  const [porcents, setPorcents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPorcentPrice = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${url}/PorcentPrice`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setPorcents(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPorcentPrice();
  }, [accessToken, url]);

  return { porcents, loading, error };
};

export {usePorcentPrice};
